// Toast gösterme fonksiyonu
function showToast(msg, duration = 2000) {
  // Aynı anda birden fazla toast olmasın
  const existing = document.querySelector('.toast-notification');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.className = 'toast-notification';
  toast.textContent = msg;

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('hide');
    setTimeout(() => toast.remove(), 300);
  }, duration);
}

// Toast spam engelleyici (çok hızlı tetiklenmesin)
let lastToastTime = 0;
function safeToast(msg) {
  const now = Date.now();
  if (now - lastToastTime > 500) {
    showToast(msg);
    lastToastTime = now;
  }
}

// ==========================
// FETCH YAKALAMA
// ==========================
const _fetch = window.fetch;

window.fetch = function (...args) {
  const url = args[0];

  let requestUrl = '';

  if (typeof url === 'string') {
    requestUrl = url;
  } else if (url instanceof Request) {
    requestUrl = url.url;
  }

  const isCartAdd = requestUrl.includes('/cart/add');
  const isCartChange = requestUrl.includes('/cart/change');
  const isCartUpdate = requestUrl.includes('/cart/update');

  return _fetch.apply(this, args).then((response) => {
    if (response.ok) {
      
      // ==========================
      // ÜRÜN EKLENDİ
      // ==========================
      if (isCartAdd) {
        safeToast('Sepete eklendi ✓');

        // Sepet ikonunu güncelle
        if (window.publish && window.PUB_SUB_EVENTS) {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'custom-add',
                cartData: cart
              });
            });
        }

      // ==========================
      // SEPET GÜNCELLENDİ
      // ==========================
      } else if (isCartChange || isCartUpdate) {
        safeToast('Sepet güncellendi ✓');

        if (window.publish && window.PUB_SUB_EVENTS) {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'custom-change',
                cartData: cart
              });
            });
        }
      }
    }

    return response;
  });
};

// ==========================
// XHR YAKALAMA (fallback)
// ==========================
const _open = XMLHttpRequest.prototype.open;
const _send = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  this._url = url;
  return _open.call(this, method, url, ...rest);
};

XMLHttpRequest.prototype.send = function (...args) {
  this.addEventListener('load', () => {
    if (!this._url) return;

    const isCartAdd = this._url.includes('/cart/add');
    const isCartChange = this._url.includes('/cart/change');
    const isCartUpdate = this._url.includes('/cart/update');

    if (this.status >= 200 && this.status < 300) {
      if (isCartAdd) {
        safeToast('Sepete eklendi ✓');
      } else if (isCartChange || isCartUpdate) {
        safeToast('Sepet güncellendi ✓');
      }
    }
  });

  return _send.apply(this, args);
};
// ==========================
// BULK ADD BUTTON
// ==========================
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.bulk-add-btn');
  if (!btn) return;

  const bulkContainer = btn.closest('quick-add-bulk');
  if (!bulkContainer) return;

  const input = bulkContainer.querySelector('input[type="number"]');
  const quantity = parseInt(input?.value || 1);

  const variantId = btn.dataset.variantId;

  if (quantity <= 0) {
    safeToast('Lütfen adet seçin');
    return;
  }

  // Buton loading
  btn.disabled = true;
  const originalText = btn.textContent;
  btn.textContent = 'Ekleniyor...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
    .then(res => res.json())
    .then(() => {
      safeToast('Sepete eklendi ✓');

      btn.textContent = 'Eklendi ✓';

      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    })
    .catch(() => {
      btn.textContent = 'Hata!';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    });
});